import type { BoggleGameModeId } from '~/boggle/gameModes'

const BOGGLE_ACTIVE_GAME_MODE_STORAGE_KEY = 'boggle.active-game-mode.v1'

function canUseStorage() {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'
}

function normalizeStoredGameMode(value: unknown): BoggleGameModeId | null {
  return value === 'sprint' || value === 'reboot' || value === 'race' || value === 'race-hard'
    ? value
    : null
}

export function readBoggleActiveGameModeFromStorage(): BoggleGameModeId | null {
  if (!canUseStorage()) {
    return null
  }

  return normalizeStoredGameMode(
    window.sessionStorage.getItem(BOGGLE_ACTIVE_GAME_MODE_STORAGE_KEY),
  )
}

export function clearBoggleActiveGameModeFromStorage() {
  if (!canUseStorage()) {
    return
  }

  window.sessionStorage.removeItem(BOGGLE_ACTIVE_GAME_MODE_STORAGE_KEY)
}

export function writeBoggleActiveGameModeToStorage(gameModeId: BoggleGameModeId) {
  if (canUseStorage()) {
    window.sessionStorage.setItem(BOGGLE_ACTIVE_GAME_MODE_STORAGE_KEY, gameModeId)
  }

  return gameModeId
}
